import { Controller } from '@hotwired/stimulus'

// Makes a whole table row clickable, navigating to its url value. Real links
// and buttons inside the row keep their own behavior, and selecting text in a
// cell does not navigate.
export default class extends Controller {
  static values = { url: String }

  open(event) {
    if (event.target.closest('a, button, input, select, label')) return
    if (window.getSelection().toString()) return
    window.Turbo.visit(this.urlValue)
  }
}
